exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid;border-top:1px solid;border-left:1px solid;border-right:1px solid;border-bottom:0 solid;border-radius:4px 4px 0 0}a{background-color:#fff}.nav-tabs>li>a{color:#000;font-weight:600;padding:10px 20px 10px 25px}.tabs-container .nav-tabs>li.active>a,.tabs-container .nav-tabs>li.active>a:focus,.tabs-container .nav-tabs>li.active>a:hover{border-top:1px solid #000;border-left:1px solid #000;border-right:1px solid #000;border-bottom:0 solid;border-bottom-color:transparent;background-color:#3f76b3}.tabs-container .nav-tabs li.active a,.tabs-container .nav-tabs li.active a:focus{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/account.management/view.account.component.css
// module id = 1526
// module chunks = 0